/* eslint-disable import/prefer-default-export */
import request from '../utils/request';
import { exportExcel } from '../utils/tools';
// 单独的开发票的方法（黄山）


// 获取电子发票列表
export const indInvoiceList = (data, corpCode) => request({
  url: '/manage/eInvoice/api/einvoice/invoiceGrid',
  method: 'post',
  data,
  corpCode,
});
// 获取电子发票金额统计
export const indInvoiceTotalPrice = (data, corpCode) => request({
  url: '/manage/eInvoice/api/einvoice/invoiceSummary',
  method: 'post',
  data,
  corpCode,
});
// 导出电子发票
export const invoiceExport = (params) => exportExcel({
  url: '/manage/eInvoice/api/einvoice/invoiceExport',
  params,
});

// 订单开票列表
// 获取开票订单列表
export const indBbillingOrderList = (data, corpCode) => request({
  url: '/manage/eInvoice/api/einvoice/orderGrid',
  method: 'post',
  data,
  corpCode,
});
// indOrderSummary
export const indOrderSummary = (data, corpCode) => request({
  url: '/manage/eInvoice/api/einvoice/orderSummary',
  method: 'post',
  data,
  corpCode,
});
// 检查开票类型
export const indInvoiceModelCheck = (data, corpCode) => request({
  url: '/manage/eInvoice/api/einvoice/invoiceModelCheck',
  method: 'post',
  type: 'json',
  data,
  corpCode,
});
// 获取开票主体
export const indparamGrid = (data, corpCode) => request({
  url: '/manage/eInvoice/api/einvoice/paramGrid',
  method: 'post',
  data,
  corpCode,
});

// 获取税收分类编号
export const getParamById = (data, corpCode) => request({
  url: '/manage/eInvoice/api/einvoice/getParamById',
  method: 'post',
  data,
  corpCode,
});
// 开票
export const indCreateInvoiceReq = (data, corpCode) => request({
  url: '/manage/eInvoice/api/einvoice/createInvoiceReq',
  method: 'post',
  type: 'json',
  data,
  corpCode,
});
// 导出（未开票）
export const indexportExcelRecords = (params) => exportExcel({
  url: '/manage/eInvoice/api/einvoice/orderExport',
  params,
});
// 模糊搜索开票主体
export const indquerySaleDutyByname = (data, corpCode) => request({
  url: '/pubs/manage/eInvoice/webApi/einvoiceParam/saleDutyQueryByCorpCodeAndName',
  method: 'post',
  type: 'json',
  data,
  corpCode,
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sditest/electronic-invoice-api/src/api/independentInvoice.js
// module id = FslD
// module chunks = 70